import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PostDraft {
  id: string;
  title: string;
  description: string;
  tags: string[];
  categories: string[];
  placeRefId: string;
  tripType: string;
  // selectedTripId: string;
  linkTo: {
    id: string;
    module: string;
  } | null;
  location: {
    coordinates: [number, number] | null;
    name: string;
  };
  files: {
    fileKey: string;
    fileType: string;
    featured?: boolean;
  }[];
  author: {
    _id: string;
    username: string;
  };
  imagesData: any[];
  videosData: any[];
  type: string;
  createdAt: string;
  updatedAt: string;
}

interface DraftState {
  drafts: PostDraft[];
}

const initialState: DraftState = {
  drafts: [],
};

const DraftSlice = createSlice({
  name: 'draft',
  initialState,
  reducers: {
    saveDraft: (state, action: PayloadAction<Omit<PostDraft, 'id' | 'createdAt' | 'updatedAt'>>) => {
      const newDraft: PostDraft = {
        ...action.payload,
        id: Date.now().toString(),
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      };
      state.drafts.push(newDraft);
    },
    updateDraft: (state, action: PayloadAction<{ id: string; draft: Partial<PostDraft> }>) => {
      const { id, draft } = action.payload;
      const draftIndex = state.drafts.findIndex(d => d.id === id);
      if (draftIndex !== -1) {
        state.drafts[draftIndex] = {
          ...state.drafts[draftIndex],
          ...draft,
          id, // Ensure ID doesn't change
          updatedAt: new Date().toISOString(),
        };
      }
    },
    deleteDraft: (state, action: PayloadAction<string>) => {
      state.drafts = state.drafts.filter(draft => draft.id !== action.payload);
    },
    clearAllDrafts: (state) => {
      state.drafts = [];
    },
    setDrafts: (state, action: PayloadAction<PostDraft[]>) => {
      state.drafts = action.payload;
    },
  },
});

export const { saveDraft, updateDraft, deleteDraft, clearAllDrafts, setDrafts } = DraftSlice.actions;
export default DraftSlice.reducer;
